const config = {
  local: {
    REACT_APP_API_URL: "",
  },
  dev: {
    REACT_APP_API_URL: "https://backoffice.cloud-dev.enyring.eu/api",
  },
  stage: {
    REACT_APP_API_URL: "https://backoffice.cloud-stag.enyring.eu/api",
  },
  prod: {
    REACT_APP_API_URL: "https://backoffice.cloud.enyring.eu/api",
  },
};

export const getBaseUrl = () => {
  switch (process.env.REACT_APP_SETTINGS) {
    case "prod":
      return config.prod.REACT_APP_API_URL;
    case "stage":
      return config.stage.REACT_APP_API_URL;
    case "dev":
      return config.dev.REACT_APP_API_URL;
    case "local":
      return config.local.REACT_APP_API_URL;
    default:
      return config.dev.REACT_APP_API_URL;
  }
};

const msalSettings = {
  local: {
    msalConfig: {
      auth: {
        clientId: "4c4433bf-5097-4106-b46d-90e0c45f4c9a", // Inserisci il tuo Application (client) ID
        authority:
          "https://login.cloud-dev.enyring.eu/8b310aa3-5736-4596-a103-b23bd02fcdbd",
        knownAuthorities: ["login.cloud-dev.enyring.eu"],
        redirectUri: "http://localhost:3000",
      },
      cache: {
        cacheLocation: "localStorage", // oppure "sessionStorage"
        storeAuthStateInCookie: false,
      },
    },
    loginRequest: {
      scopes: [
        "api://6a1cbaa5-81cd-425b-8e34-10b5a25b4176/enyring.backend.backoffice",
      ],
      prompt: "select_account",
    },
  },
  dev: {
    msalConfig: {
      auth: {
        clientId: "4c4433bf-5097-4106-b46d-90e0c45f4c9a", // Inserisci il tuo Application (client) ID
        authority:
          "https://login.cloud-dev.enyring.eu/8b310aa3-5736-4596-a103-b23bd02fcdbd",
        knownAuthorities: ["login.cloud-dev.enyring.eu"],
        redirectUri: "https://backoffice.cloud-dev.enyring.eu/",
      },
      cache: {
        cacheLocation: "localStorage", // oppure "sessionStorage"
        storeAuthStateInCookie: false,
      },
    },
    loginRequest: {
      scopes: [
        "api://6a1cbaa5-81cd-425b-8e34-10b5a25b4176/enyring.backend.backoffice",
      ],
      prompt: "select_account",
    },
  },
  stage: {
    msalConfig: {
      auth: {
        clientId: "99c373e3-5c9c-455f-9cc2-5dd56fe4161f", // Inserisci il tuo Application (client) ID
        authority:
          "https://login.cloud-stag.enyring.eu/89150cd6-e5f0-4d09-846d-173f7a4bedaa",
        knownAuthorities: ["login.cloud-stag.enyring.eu"],
        redirectUri: "https://backoffice.cloud-stag.enyring.eu/",
      },
      cache: {
        cacheLocation: "localStorage", // oppure "sessionStorage"
        storeAuthStateInCookie: false,
      },
    },
    loginRequest: {
      scopes: [
        "api://b7ebcbac-c3b5-41da-b252-0536659781b1/enyring.backend.backoffice",
      ],
      prompt: "select_account",
    },
  },
  prod: {
    msalConfig: {
      auth: {
        clientId: "a5c39bda-7aa1-4bcf-822f-43e0da44608c",
        authority:
          "https://login.cloud.enyring.eu/c847813d-8c4d-43a6-8fac-14e1e530f2bb",
        knownAuthorities: ["login.cloud.enyring.eu"],
        redirectUri: "https://backoffice.cloud.enyring.eu/",
      },
      cache: {
        cacheLocation: "localStorage", // oppure "sessionStorage"
        storeAuthStateInCookie: false,
      },
    },
    loginRequest: {
      scopes: [
        "api://e3abdac2-e22b-4c13-866a-e58200817f0d/enyring.backend.backoffice",
      ],
      prompt: "select_account",
    },
  },
};

export const msalConfig = () => {
  switch (process.env.REACT_APP_SETTINGS) {
    case "prod":
      return msalSettings.prod.msalConfig;
    case "stage":
      return msalSettings.stage.msalConfig;
    case "dev":
      return msalSettings.dev.msalConfig;
    case "local":
      return msalSettings.local.msalConfig;
    default:
      return msalSettings.local.msalConfig;
  }
};

export const loginRequest = () => {
  switch (process.env.REACT_APP_SETTINGS) {
    case "prod":
      return msalSettings.prod.loginRequest;
    case "stage":
      return msalSettings.stage.loginRequest;
    case "dev":
      return msalSettings.dev.loginRequest;
    case "local":
      return msalSettings.local.loginRequest;
    default:
      return msalSettings.local.loginRequest;
  }
};
